
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/assembly-chunav/assam/exit-poll",
      function () {
        return require("private-next-pages/elections/assembly-chunav/assam/exit-poll/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/assembly-chunav/assam/exit-poll"])
      });
    }
  